import { render } from "./ListOfProductions.vue?vue&type=template&id=1bd99ade&ts=true"
import script from "./ListOfProductions.vue?vue&type=script&lang=ts"
export * from "./ListOfProductions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__